import { render, staticRenderFns } from "./UninstallTable.vue?vue&type=template&id=bef9714c"
import script from "./UninstallTable.vue?vue&type=script&lang=js"
export * from "./UninstallTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports